import { h } from 'preact';
import ButtonWrapper from './generics/ButtonWrapper';

export default ({
  buttonText = 'Regístrate',
  invitationText = '¿Aún no eres Socio Siempre Plus?',
  isLoading,
  onClick,
}) => (
  <div className="purchase-signin">
    <h6 className="purchase-signin-title">{invitationText}</h6>

    <ButtonWrapper
      className="purchase-signin-button"
      type="button"
      onClick={onClick}
      isLoading={isLoading}
    >
      {buttonText}
    </ButtonWrapper>
  </div>
);



// WEBPACK FOOTER //
// ./components/SignInButton.js